import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToTarget } from "./useLenis";

// Unified navigation: "#anchor" scrolls on the homepage (navigating home first
// if needed); any other target is treated as a route (e.g. "/careers").
export function useSiteNav() {
    const navigate = useNavigate();
    const location = useLocation();

    return useCallback(
        (target) => {
            if (target.startsWith("#")) {
                if (location.pathname !== "/") {
                    navigate("/");
                    setTimeout(() => scrollToTarget(target), 150);
                } else {
                    scrollToTarget(target);
                }
            } else {
                navigate(target);
                setTimeout(() => window.scrollTo(0, 0), 60);
            }
        },
        [navigate, location.pathname]
    );
}
